export default "images/组 25.png";